<template>
    <el-dialog title="编辑会员资料" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="用户id" :label-width="formLabelWidth">
                <el-input v-model="form.user_id" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="昵称" :label-width="formLabelWidth">
                <el-input v-model="form.nickName" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" autocomplete="off" readonly></el-input>
            </el-form-item>
        
            <el-form-item label="绑定上级"  :label-width="formLabelWidth">
                <el-row>
                <el-button @click="addClick" icon="el-icon-plus">选择上级</el-button>
                <div v-if="form.referee_id!=''" class="img">
                    <img :src="form.agent.avatarUrl" width="100" height="100" />
                </div>
                <div>
                    <el-link :underline="false" disabled>选择后不可更改</el-link>
                </div>
                </el-row>
            </el-form-item>


            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>

        <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>

    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    import GetUser from '@/components/user/GetUser.vue';
    export default {
        components: {
        /*编辑组件*/
        GetUser
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                open_add:false,
        
            };
        },
        props: ['open_relation','form'],
        created() {
            this.dialogVisible = this.$parent.open_relation;
        },
        methods: {
              /*打开弹出层*/
            addClick() {
                this.open_add = true;
            },

            /*关闭获取用户弹窗*/
            closeDialogFunc(e) {
                if (e.type != 'error') {
                this.form.agent = e.params[0];
                this.form.referee_id = e.params[0].user_id;
                }
                this.open_add = false;
            },
    
            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                UserApi.relation(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '恭喜你，用户推荐人修改成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Relation.vue